import { ThemeOptions } from '@melio/penny';

import { Spinner } from './loader';
import { FiservLogo, FiservLogoDark } from './logos';

export const fiservTheme: ThemeOptions = {
  loader: Spinner,
  logos: {
    light: FiservLogo,
    dark: FiservLogoDark,
  },
  fonts: {
    primary: 'Circular,Helvetica,Arial,sans-serif',
  },
  colors: {
    brand: {
      darkest: '#014E74',
      dark: '#003cc8',
      main: '#235AE4',
      light: '#598AAA',
      lighter: '#8AB0C7',
      lightest: '#B3CDDE',
    },
    warning: {
      main: '#F9C606',
      lightest: '#FFF1D0',
    },
    success: {
      darkest: '#185309',
      dark: '#1E6A0B',
      main: '#25810E',
      lightest: '#DAE8D8',
    },
    info: {
      main: '#0276B1',
      lightest: '#E1F5FF',
    },
    critical: {
      darkest: '#A3282B',
      dark: '#BA2629',
      main: '#CC2427',
      lightest: '#FFE5E6',
    },
    neutral: {
      black: '#141414',
      darkest: '#676868',
      darker: '#7D7D7D',
      dark: '#AFB0AF',
      light: '#D7D7D7',
      lighter: '#E6E6E6',
      lightest: '#FAFAFA',
      white: '#FFFFFF',
    },
    link: {
      rest: 'brand.main',
      hover: 'brand.dark',
      pressed: 'brand.dark',
    },
    components: {
      nakedButton: {
        secondary: {
          default: { color: 'link.rest' },
          hover: { color: 'link.hover' },
          active: { color: 'link.pressed' },
        },
      },
    },
  },
};
